import { useState } from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { cn } from '@/new/lib/utils';

export function CopyIconButton({ getText, className }: { getText: () => string; className?: string }) {
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText(getText());
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Button variant="ghost" onClick={handleClick} className="p-1 px-1.5">
      <AnimatePresence mode="wait">
        {copied ? (
          <motion.span
            key="check"
            initial={{ opacity: 0, filter: 'blur(2px)' }}
            animate={{ opacity: 1, filter: 'blur(0px)' }}
            exit={{ opacity: 0, filter: 'blur(2px)' }}
            transition={{ duration: 0.1 }}
          >
            <Icon className={cn('lucide--check', className)} />
          </motion.span>
        ) : (
          <motion.span
            key="copy"
            initial={{ opacity: 0, filter: 'blur(2px)' }}
            animate={{ opacity: 1, filter: 'blur(0px)' }}
            exit={{ opacity: 0, filter: 'blur(2px)' }}
            transition={{ duration: 0.1 }}
          >
            <Icon className={cn('lucide--copy', className)} />
          </motion.span>
        )}
      </AnimatePresence>
    </Button>
  );
}
